"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _FormDestinationPicker = require("./FormDestinationPicker");

var _default = _FormDestinationPicker.FormDestinationPicker;
exports["default"] = _default;